import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["data-testid"]
const _hoisted_2 = {
  class: "h-10 w-10 text-negative",
  viewBox: "0 0 24 24",
  "aria-hidden": "true"
}
const _hoisted_3 = ["d"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "m-0 font-bold text-textPrimary" }, " Não foi possível carregar os pagamentos prioritários ", -1)
const _hoisted_5 = ["data-testid"]
const _hoisted_6 = ["data-testid"]

import { mdiAlertCircleOutline } from '@mdi/js'


export default /*#__PURE__*/_defineComponent({
  __name: 'PriorityPaymentsErrorState',
  props: {
    message: {},
    testId: { default: 'priority-payments-error-state' }
  },
  emits: ["retry"],
  setup(__props: any, { emit }) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "flex w-full flex-col items-center justify-center gap-4 py-16 text-center",
    role: "alert",
    "aria-live": "assertive",
    "data-testid": _ctx.testId
  }, [
    (_openBlock(), _createElementBlock("svg", _hoisted_2, [
      _createElementVNode("path", {
        d: _unref(mdiAlertCircleOutline),
        fill: "currentColor"
      }, null, 8, _hoisted_3)
    ])),
    _hoisted_4,
    (_ctx.message)
      ? (_openBlock(), _createElementBlock("p", {
          key: 0,
          class: "m-0 text-sm text-neutral50",
          "data-testid": `${_ctx.testId}-message`
        }, _toDisplayString(_ctx.message), 9, _hoisted_5))
      : _createCommentVNode("", true),
    _createElementVNode("button", {
      type: "button",
      class: "rounded-md border border-lightGray30 px-4 py-2 text-sm font-medium text-textPrimary",
      "data-testid": `${_ctx.testId}-retry`,
      onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('retry')))
    }, " Tentar novamente ", 8, _hoisted_6)
  ], 8, _hoisted_1))
}
}

})